import { useState, useEffect } from "react";
import { Link2, FileText, Film, Search } from "lucide-react";
import { toast } from "sonner";
import crm, { apiErr } from "../crmApi";
import { Loader } from "../CrmApp";
import { inr, fileSrc, useWmPerms } from "./WebsiteApp";

export const listingUrl = (slug) => `${window.location.origin}/property/${slug}`;
const copy = (t) => { navigator.clipboard?.writeText(t); toast.success("Link copied"); };

function Listing({ p }) {
  const media = [...p.gallery.map((u) => ["image", u]), ...p.videos.map((u) => ["video", u]), ...p.floor_plans.map((u) => ["doc", u])];
  return (
    <div className="crm-card p-4" data-testid={`wm-media-listing-${p.slug}`}>
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div><p className="font-bold text-pbs-dark">{p.name}</p><p className="text-xs text-pbs-grey">{p.developer} · {p.locality}, {p.city} · from {inr(p.price)} · approved v{p.version}</p></div>
        <div className="flex gap-2">
          <button onClick={() => copy(listingUrl(p.slug))} data-testid={`wm-copy-link-${p.slug}`} className="text-xs font-bold text-pbs-purple border border-pbs-purple/30 rounded-lg px-2.5 py-1.5 inline-flex items-center gap-1"><Link2 size={13} /> Copy page link</button>
          {p.brochure && <a href={fileSrc(p.brochure)} target="_blank" rel="noreferrer" className="text-xs font-bold text-pbs-dark border border-pbs-line rounded-lg px-2.5 py-1.5 inline-flex items-center gap-1"><FileText size={13} /> Brochure</a>}
        </div>
      </div>
      <div className="mt-3 flex gap-2 overflow-x-auto no-scrollbar">
        {media.map(([k, u], i) => (
          <a key={i} href={fileSrc(u)} target="_blank" rel="noreferrer" className="relative shrink-0 w-28 aspect-[4/3] rounded-lg overflow-hidden bg-pbs-bg border border-pbs-line">
            {k === "image" ? <img src={fileSrc(u)} alt="" loading="lazy" className="w-full h-full object-cover" /> : <span className="w-full h-full flex items-center justify-center text-pbs-purple">{k === "video" ? <Film size={20} /> : <FileText size={20} />}</span>}
          </a>
        ))}
      </div>
    </div>
  );
}

export default function WmMedia() {
  const perms = useWmPerms();
  const [data, setData] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { crm.wm.media().then(setData).catch((e) => { toast.error(apiErr(e)); setData({ listings: [], uploads: [] }); }); }, []);
  if (!data) return <Loader />;
  const list = data.listings.filter((p) => `${p.name} ${p.developer} ${p.city} ${p.locality}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="space-y-3">
      <p className="text-sm text-pbs-grey">Only published, approved listing media is shown here. To send a listing to a customer, open the lead and use <b>Share Property</b>, which records exactly what was sent.</p>
      <div className="flex items-center gap-2 border border-pbs-line bg-white rounded-lg px-3"><Search size={15} className="text-pbs-grey" /><input data-testid="wm-media-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search approved listings" className="flex-1 py-2 outline-none text-sm bg-transparent" /></div>
      {list.map((p) => <Listing key={p.id} p={p} />)}
      {list.length === 0 && <p className="text-sm text-pbs-grey p-6 text-center">No approved listings found.</p>}
      {perms.can_edit && data.uploads.length > 0 && (
        <div className="crm-card p-4">
          <h3 className="font-bold text-pbs-dark mb-2">Recent uploads (all, including drafts)</h3>
          <div className="grid grid-cols-3 sm:grid-cols-6 lg:grid-cols-8 gap-2">
            {data.uploads.map((m) => (
              <a key={m.id} href={fileSrc(m.url)} target="_blank" rel="noreferrer" title={`${m.filename} · ${m.uploaded_by}`} className="aspect-square rounded-lg overflow-hidden bg-pbs-bg border border-pbs-line flex items-center justify-center text-pbs-purple">
                {m.kind === "image" ? <img src={fileSrc(m.url)} alt="" loading="lazy" className="w-full h-full object-cover" /> : m.kind === "video" ? <Film size={18} /> : <FileText size={18} />}
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
